<ng-container *ngIf="cartMessage$|async as cartMessage">

  <div [innerHTML]="cartMessage" class="mt-n3 mb-3">
  </div>

</ng-container>
